<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'app'
}

</script>
<style lang="scss">
// CoreUI Icons Set

/* @import '../node_modules/@coreui/icons/css/coreui-icons.min.css'; */


/* Import Font Awesome Icons Set */

$fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
@import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
@import '~@fortawesome/fontawesome-free/scss/solid.scss';
@import '~@fortawesome/fontawesome-free/scss/brands.scss';
@import '~@fortawesome/fontawesome-free/scss/regular.scss';




/* Import Simple Line Icons Set */

$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';



/* Import Flag Icons Set */


/* @import '../node_modules/flag-icon-css/css/flag-icon.min.css'; */


/* Import Bootstrap Vue Styles */

@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'; // Import Main styles for this application
@import 'assets/scss/style';

</style>



// WEBPACK FOOTER //
// src/App.vue